const WelcomePage = async () =>
    import('../../pages/home/WelcomePage').then((module) => ({
        Component: module.WelcomePage,
    }));

const getWelcomePageRoutes = () => {
    return [
        {
            path: '/home/',
            lazy: WelcomePage,
        },
    ];
};

export { getWelcomePageRoutes };
